// ProjectContext.js
import React, { createContext, useContext, useState } from "react";
import { projects as localProjects } from "../data/projects";

const ProjectContext = createContext();

export const useProjects = () => useContext(ProjectContext);

export function ProjectProvider({ children }) {
  const [projects, setProjects] = useState(localProjects);

  return (
    <ProjectContext.Provider value={{ projects, setProjects }}>
      {children}
    </ProjectContext.Provider>
  );
}
